module.exports = __webpack_public_path__ + "static/media/brush.98923cd6.cur";